import { render, staticRenderFns } from "./VBugReport.vue?vue&type=template&id=4eec1d48&scoped=true"
import script from "./VBugReport.vue?vue&type=script&lang=js"
export * from "./VBugReport.vue?vue&type=script&lang=js"
import style0 from "./VBugReport.vue?vue&type=style&index=0&id=4eec1d48&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eec1d48",
  null
  
)

export default component.exports